import radianToDegree from "../../../../../../../src/utils/math/radianToDegree";
import { Direction, QuestionType } from "../../../types/Enum";


export default function getDescription(qType: QuestionType, rotation: number) {
  if (qType == QuestionType.TYPE1) {
    const dir = rotation < 0 ? Direction.antiClockwise : Direction.clockwise;
    return `Rotate the shape ${Math.abs(radianToDegree(rotation))} degrees ${dir} about point.`
  } else if (qType == QuestionType.TYPE2) {
    return "Describe the single transformation from shape A to shape B."
  }
}